export const NO_COMMUNICATION_VEHICLE = 'no_communication_vehicle';
export const NO_COMMUNICATION_SECONDARIES = 'no_communication_secondaries';
export const DISCONNECTION_ALARM = 'disconnection_alarm';
export const LOW_BATTERY_ALARM = 'low_battery_alarm';
export const LINKED_SEPARATION = 'linked_separation';
export const CONVOY_SEPARATION = 'convoy_separation';
export const MULTIPLE_DEVICE_SEPARATION = 'multiple_device_separation';